import { render, staticRenderFns } from "./KnFormSpecialGroups.vue?vue&type=template&id=0396d00c"
import script from "./KnFormSpecialGroups.js?vue&type=script&lang=js&external"
export * from "./KnFormSpecialGroups.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports